<div class="container-fluid my-2 px-0">

  @if (isLoading) {
  <div class="spinner">
    <mat-spinner>{{ 'SHUTTLE_CHECKIN.LOADING' | transloco }}...</mat-spinner>
  </div>
  }
  <div id="outer">
    @if (!isBtnPlannedDisabled) {
    <div class="button-row">
      <button (click)="setBusPlanned(orderShuttleBus.orderShuttleBusId)" class="status-button"
        mat-raised-button color="primary">
        {{ 'SHUTTLE_CHECKIN.PLANNED' | transloco }}
      </button>&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    }
    @if (!isBtnActiveDisabled) {
    <div class="button-row">
      <button (click)="setBusActive(orderShuttleBus.orderShuttleBusId)" class="status-button"
        mat-raised-button color="primary">
        {{ 'SHUTTLE_CHECKIN.ACTIVATE' | transloco}}
      </button>&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    }
    <!--<button (click)="setBusDeparted(orderShuttleBus.orderShuttleBusId)" class="status-button" mat-raised-button color="primary">Avgång</button>&nbsp;&nbsp;&nbsp;&nbsp;-->
    @if (!isBtnArrivalDisabled) {
    <div class="button-row">
      <button (click)="setBusArrived(orderShuttleBus.orderShuttleBusId)" class="status-button"
        mat-raised-button color="primary">{{ 'SHUTTLE_CHECKIN.ARRIVAL' | transloco }}
      </button>&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    }
    @if (!isBtnCancelledDisabled) {
    <div class="button-row">
      <button (click)="setBusCancelled(orderShuttleBus.orderShuttleBusId)" class="status-button"
        mat-raised-button color="warn">Cancel</button>&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    }
    @if (!isBtnQRDisabled) {
    <div class="button-row">
      <button class="status-button" mat-raised-button>{{ 'SHUTTLE_CHECKIN.PLANNED' | transloco }}</button>
    </div>
    }
  </div>
  <mat-expansion-panel hideToggle class="group-card">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>directions_bus</mat-icon>&nbsp;&nbsp;
        {{ orderShuttleBus.routeName }}&nbsp;
        {{orderShuttleBus.startDate | date: 'yyyy-MM-dd HH:mm' }}<div class="spacer"></div>&nbsp;
        <app-status-badge [text]="orderShuttleBus.status" [isBooking]="true"></app-status-badge>&nbsp;&nbsp;
        <!-- <mat-icon (click)="editOrderShuttleBus()">edit</mat-icon> -->
      </mat-panel-title>
    </mat-expansion-panel-header>
    <table class="shuttle-details-table">
      <tr>
        <td>
          {{ 'SHUTTLE_CHECKIN.DEPARTURE' | transloco}}:
        </td>
        <td>
          {{ orderShuttleBus.startDate | date: 'yyyy-MM-dd HH:mm'}}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'SHUTTLE_CHECKIN.ARRIVAL' | transloco}}:
        </td>
        <td>
          {{ orderShuttleBus.endDate | date: 'yyyy-MM-dd HH:mm'}}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'SHUTTLE_CHECKIN.BUS' | transloco}}:
        </td>
        <td>
          {{ orderShuttleBus.busName }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'SHUTTLE_CHECKIN.BUS_DRIVER' | transloco}}:
        </td>
        <td>
          {{ orderShuttleBus.driverName }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'SHUTTLE_CHECKIN.NO_OF_SEATS' | transloco}}:
        </td>
        <td>
          {{ orderShuttleBus.seats }}
        </td>
      </tr>
    </table>
  </mat-expansion-panel>

  <!-- <mat-accordion multi> -->
  <!-- <mat-accordion multi> -->

  <!-- CHECKED_IN_PASSENGERS -->
  <mat-card class="group-card p-0">
    <mat-card-header class="card-header">
      <div class="d-flex flex-col pe-3">
        <mat-card-title>
          <mat-icon>playlist_add_check</mat-icon>&nbsp;
          {{ 'SHUTTLE_CHECKIN.CHECKED_IN_PASSENGERS' | transloco}}
        </mat-card-title>
      </div>
      <div class="table-extras">
        <mat-checkbox [checked]="showCustDetailsBoarded"
          (change)="changeShowCustDetailsBoarded($event)"><mat-icon>person</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-checkbox [checked]="showFlightDetailsBoarded"
          (change)="changeShowFlightDetailsBoarded($event)"><mat-icon>flight</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-icon class="clickable"
          (click)="getOrderShuttlesBoarded(orderShuttleBus.orderShuttleBusId)">refresh</mat-icon>
      </div>
    </mat-card-header>
    <div class="p-0 table-responsive">
      <table>
        <tr>
          <th>{{ 'SHUTTLE_CHECKIN.NAME' | transloco}}</th>
          <th>{{ 'SHUTTLE_CHECKIN.REG_NO' | transloco}}</th>
          <th>{{ 'SHUTTLE_CHECKIN.PASSENGER' | transloco}}</th>
          <!-- <th>{{ 'SHUTTLE_CHECKIN.BOOKED_TIME' | transloco}}</th> -->
          @if (orderShuttleBus.routeType == 'ARRIVAL' ) {
          <th>
            {{ 'SHUTTLE_CHECKIN.NEW_TIME' | transloco}}
          </th>
          }
          <!-- <th *ngIf="orderShuttleBus.routeType == 'ARRIVAL' ">
              {{ 'SHUTTLE_CHECKIN.READY_TO_TRANSFER' | transloco}}
            </th> -->
          <th>Station</th>
          <th>Destination</th>
          <th>{{ 'SHUTTLE_CHECKIN.ORDER_NO' | transloco}}</th>
          <th>{{ 'SHUTTLE_CHECKIN.CHECKED_IN' | transloco}}</th>
          <!-- <th>{{ 'SHUTTLE_CHECKIN.UNDO' | transloco}}</th> -->
          <th>{{ 'SHUTTLE_CHECKIN.KEY_STATUS' | transloco}}</th>
          <th>Safe details</th>
        </tr>
        <!-- <mat-divider></mat-divider> -->
        @for (orderShuttle of orderShuttlesBoarded; track orderShuttle) {
        <tr [ngClass]="{'hotel-row': isHotel(orderShuttle), 'non-hotel-row': !isHotel(orderShuttle)}">
          <td (click)="goToOrder(orderShuttle)" class="clickable">
            {{ orderShuttle.firstName }} {{ orderShuttle.lastName }}
            @if (isHotel(orderShuttle)) {
            <mat-icon class="icon-bottom ms-1 icon-scale-small">hotel</mat-icon>
            }
            @if (orderShuttle.hasDevice) {
            <mat-icon class="icon-bottom icon-scale-tiny">mobile_friendly</mat-icon>
            }
            @if (orderShuttle.extra?.pressedButtonInApp) {
            <mat-icon class="icon-bottom icon-scale-tiny">waving_hand</mat-icon>
            }
            @if (isRedKeyStatus(orderShuttle.keyStatus) || isGreenKeyStatus(orderShuttle.keyStatus) ||
            isBlueKeyStatus(orderShuttle.keyStatus)) {
            <mat-icon class="icon-bottom"
              [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(orderShuttle.keyStatus) ? 'red' : (isGreenKeyStatus(orderShuttle.keyStatus) ? 'green' : (isBlueKeyStatus(orderShuttle.keyStatus) ? '#3f51b5' : ''))}">key
            </mat-icon>
            @if (orderShuttle.orderSafe?.hookNo) {
            <span class="key-hook-number">{{ "(Hook No: " + orderShuttle.orderSafe.hookNo + ")" }}</span>
            }
            }
          </td>
          <td (click)="goToOrder(orderShuttle)" class="clickable">
            {{ orderShuttle.orderParkingCarId }}
          </td>
          <td (click)="goToOrder(orderShuttle)" class="clickable"> {{ orderShuttle.passengers }}</td>
          <!-- <td title="{{orderShuttle.shuttleDate | date:'yyyy-MM-dd HH:mm'}}"> {{ orderShuttle.shuttleDate | date: 'HH:mm' }}</td> -->
          @if (orderShuttleBus.routeType == 'DEPARTURE') {
          <td>
            @if (orderShuttle.orderParkingParkingSiteName == null) {
            <div>{{displayRouteName(orderShuttle)}}</div>
            }
            @if (orderShuttle.orderParkingParkingSiteName != null) {
            <div>
              @let hotelName = displayHotelName(orderShuttle.organizationId);
              @if(hotelName){
              {{hotelName}}
              }@else{
              @let siteName = removeLastPart(orderShuttle.orderParkingParkingSiteName);
              <span [style.color]="siteName === 'FP2' ? 'red' : 'inherit'">
                P-plats:&nbsp;{{ siteName }}
              </span>
              }
            </div>
            }
          </td>
          @if (!orderShuttle.departureVM) {
          <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
            {{ orderShuttle.terminal }}</td>
          }
          @if (orderShuttle.departureVM) {
          <td
            [ngStyle]="{color:orderShuttle.departureVM.terminalName=='Terminal 5'||orderShuttle.departureVM.terminalName=='Terminal 4'?'black':'red'}">
            {{orderShuttle.departureVM.terminalName}}</td>
          }
          }
          @if (orderShuttleBus.routeType == 'ARRIVAL') {
          <td title="{{orderShuttle.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}"
            [ngStyle]="{color:orderShuttle.isReadyForPickup?'green':'black'}">
            {{ orderShuttle.shuttleDateNew | date: 'HH:mm' }}
          </td>
          @if (!orderShuttle.arrivalVM) {
          <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
            {{ orderShuttle.terminal }}</td>
          }
          @if (orderShuttle.arrivalVM) {
          <td
            [ngStyle]="{color:orderShuttle.arrivalVM.terminalName=='Terminal 5'||orderShuttle.arrivalVM.terminalName=='Terminal 4'?'black':'red'}">
            {{orderShuttle.arrivalVM.terminalName}}</td>
          }
          <td>
            @if (orderShuttle.orderParkingParkingSiteName == null) {
            <div>{{displayRouteName(orderShuttle)}}</div>
            }
            @if (orderShuttle.orderParkingParkingSiteName != null ) {
            <div>
              @let hotelName = displayHotelName(orderShuttle.organizationId);
              @if(hotelName){
              {{hotelName}}
              }@else{
              @let siteName = removeLastPart(orderShuttle.orderParkingParkingSiteName);
              <span [style.color]="siteName === 'FP2' ? 'red' : 'inherit'">
                P-plats:&nbsp;{{ siteName }}
              </span>
              }
            </div>
            }
          </td>
          }
          <td> {{ orderShuttle.orderNr }}</td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleReadyForPickup(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="primary">
              <mat-icon class="icon-center">arrow_downward</mat-icon>
            </button>
          </td>
          <td class="key-status-cell">
            @if (showButtonForKeyStatus(orderShuttle.keyStatus)) {
            <button mat-raised-button color="primary" class="key-status-button" (click)="handleKeys(orderShuttle)">
              {{"KEY_STATUS_MESSAGE."+keyStatusDisplayMap[orderShuttle.keyStatus] | transloco}}
            </button>
            }
            @if (showTextForKeyStatus(orderShuttle.keyStatus)) {
            <div class="pl-1">{{"KEY_STATUS_MESSAGE."+keyStatusDisplayMap[orderShuttle.keyStatus] | transloco}}
            </div>
            }
          </td>
          <td>
            @if (orderShuttle?.orderSafe?.hookSafeName && orderShuttle?.orderSafe?.hookNo) {
            <div>
              {{orderShuttle?.orderSafe?.hookSafeName}} {{
              '- '+orderShuttle?.orderSafe?.hookNo}}
            </div>
            }
          </td>
        </tr>
        @if ((orderShuttle.departureVM && showFlightDetailsBoarded) || (orderShuttle.arrivalVM &&
        showFlightDetailsBoarded)) {
        <tr [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
          <td [attr.colspan]="orderShuttleBus.routeType === 'ARRIVAL' ? 10 : 9">
            @if (orderShuttle.departureVM && showFlightDetailsBoarded) {
            <div>
              <app-back-office24-ordershuttlebus-departure
                [departureVM]="orderShuttle.departureVM"></app-back-office24-ordershuttlebus-departure>
            </div>
            }
            @if (orderShuttle.arrivalVM && showFlightDetailsBoarded) {
            <div>
              <app-back-office24-ordershuttlebus-arrival
                [orderShuttleVM]="orderShuttle"></app-back-office24-ordershuttlebus-arrival>
            </div>
            }
          </td>
        </tr>
        }
        @if (showCustDetailsBoarded) {
        <tr [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
          <td [attr.colspan]="orderShuttleBus.routeType === 'ARRIVAL' ? 10 : 9">
            @if (orderShuttle.cellular) {
            <span><mat-icon>smartphone</mat-icon>&nbsp;{{orderShuttle.cellular}}</span>
            }
            <!-- </td>
                <td>
                  <span
                    *ngIf="orderShuttle.email"><mat-icon>email</mat-icon>&nbsp;{{orderShuttle.email}}</span>
                  </td>
                  <td colspan="6"> -->
            @if (orderShuttle.comment) {
            <span><mat-icon>info</mat-icon>&nbsp;{{orderShuttle.comment}}</span>
            }
          </td>
        </tr>
        }
        <!-- <mat-divider></mat-divider> -->
        }
      </table>
    </div>
  </mat-card>

  <!-- BOOKED_PASSENGERS_ON_BUS -->
  <mat-card class="group-card p-0">
    <mat-card-header class="card-header">
      <div class="d-flex flex-col pe-3">
        <mat-card-title><mat-icon>date_range</mat-icon>&nbsp;
          {{ 'SHUTTLE_CHECKIN.BOOKED_PASSENGERS_ON_BUS' | transloco}}
        </mat-card-title>
      </div>
      <div class="table-extras">
        <mat-checkbox [checked]="showCustDetailsBooked"
          (change)="changeShowCustDetailsBooked($event)"><mat-icon>person</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-checkbox [checked]="showFlightDetailsBooked"
          (change)="changeShowFlightDetailsBooked($event)"><mat-icon>flight</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-icon class="clickable"
          (click)="getOrderShuttlesPaidBus(orderShuttleBus.orderShuttleBusId)">refresh</mat-icon>
      </div>
    </mat-card-header>
    <div class="p-0 table-responsive">
      <table>
        <tr>
          <th>{{ 'SHUTTLE_CHECKIN.NAME' | transloco}}</th>
          <th>{{ 'SHUTTLE_CHECKIN.PASSENGER' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.BOOKED_TIME' | transloco }}</th>
          @if (orderShuttleBus.routeType == 'ARRIVAL' ) {
          <th>{{ 'SHUTTLE_CHECKIN.NEW_TIME' | transloco }}</th>
          }
          <th>Station</th>
          <th>Destination</th>
          <th>{{ 'SHUTTLE_CHECKIN.ORDER_NO' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.CHECKED_IN' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.UNDO' | transloco }}</th>
          <th>No Show</th>
        </tr>
        @for (orderShuttle of orderShuttlesBooked; track orderShuttle) {
        <tr [ngClass]="{'hotel-row': isHotel(orderShuttle), 'non-hotel-row': !isHotel(orderShuttle)}">
          <td (click)="goToOrder(orderShuttle)" class="clickable">
            {{ orderShuttle.firstName }} {{ orderShuttle.lastName }}
            @if (isHotel(orderShuttle)) {
            <mat-icon class="icon-bottom ms-1 icon-scale-small">hotel</mat-icon>
            }
            @if (orderShuttle.hasDevice) {
            <mat-icon class="icon-bottom icon-scale-tiny">mobile_friendly</mat-icon>
            }
            @if (orderShuttle.extra?.pressedButtonInApp) {
            <mat-icon class="icon-bottom icon-scale-tiny">waving_hand</mat-icon>
            }
            @if (isRedKeyStatus(orderShuttle.keyStatus) || isGreenKeyStatus(orderShuttle.keyStatus)) {
            <mat-icon class="icon-bottom"
              [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(orderShuttle.keyStatus) ? 'red' : (isGreenKeyStatus(orderShuttle.keyStatus) ? 'green' : '')}">key
            </mat-icon>
            @if (orderShuttle.orderSafe?.hookNo) {
            <span class="key-hook-number">{{ "(Hook No: " + orderShuttle.orderSafe.hookNo + ")" }}</span>
            }
            }
          </td>
          <td (click)="goToOrder(orderShuttle)" class="clickable"> {{ orderShuttle.passengers }}</td>
          <td (click)="goToOrder(orderShuttle)" class="clickable"
            title="{{orderShuttle.shuttleDate | date:'yyyy-MM-dd HH:mm'}}"> {{ orderShuttle.shuttleDate | date:
            'HH:mm' }}</td>
          @if (orderShuttleBus.routeType == 'DEPARTURE' ) {
          <td>{{ orderShuttle.shuttleTypeName}}</td>
          @if (!orderShuttle.departureVM) {
          <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
            {{ orderShuttle.terminal }}</td>
          }
          @if (orderShuttle.departureVM) {
          <td
            [ngStyle]="{color:orderShuttle.departureVM.terminalName=='Terminal 5'||orderShuttle.departureVM.terminalName=='Terminal 4'?'black':'red'}">
            {{orderShuttle.departureVM.terminalName}}</td>
          }
          }
          @if (orderShuttleBus.routeType == 'ARRIVAL' ) {
          <td title="{{orderShuttle.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}"
            [ngStyle]="{color:orderShuttle.isReadyForPickup?'green':'black'}"> {{
            orderShuttle.shuttleDateNew | date: 'HH:mm' }}</td>
          @if (!orderShuttle.arrivalVM) {
          <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
            {{ orderShuttle.terminal }}</td>
          }
          @if (orderShuttle.arrivalVM) {
          <td
            [ngStyle]="{color:orderShuttle.arrivalVM.terminalName=='Terminal 5'||orderShuttle.arrivalVM.terminalName=='Terminal 4'?'black':'red'}">
            {{orderShuttle.arrivalVM.terminalName}}</td>
          }
          <td>{{ orderShuttle.shuttleTypeName}}</td>
          }
          <td> {{ orderShuttle.orderNr }}</td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleBoarded(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="primary">
              <mat-icon class="icon-center">arrow_upward</mat-icon>
            </button>
          </td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleReadyForPickup(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="primary">
              <mat-icon class="icon-center">arrow_downward</mat-icon>
            </button>
          </td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleNoShow(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="warn">
              <mat-icon class="icon-center">delete_outline</mat-icon>
            </button>
          </td>
        </tr>
        @if ((orderShuttle.departureVM && showFlightDetailsBooked) || (orderShuttle.arrivalVM &&
        showFlightDetailsBooked)) {
        <tr [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
          <td>
            @if (orderShuttle.departureVM && showFlightDetailsBooked) {
            <div>
              <app-back-office24-ordershuttlebus-departure
                [departureVM]="orderShuttle.departureVM"></app-back-office24-ordershuttlebus-departure>
            </div>
            }
            @if (orderShuttle.arrivalVM && showFlightDetailsBooked) {
            <div>
              <app-back-office24-ordershuttlebus-arrival
                [orderShuttleVM]="orderShuttle"></app-back-office24-ordershuttlebus-arrival>
            </div>
            }
          </td>
          <!-- <td></td>
                    <td></td> -->
        </tr>
        }
        @if (showCustDetailsBooked) {
        <tr [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
          <td colspan="9">
            @if (orderShuttle.cellular) {
            <span>&nbsp;Contact: {{orderShuttle.cellular}}</span>
            }
            <!-- </td>
                    <td> -->
            <!-- <span
                      *ngIf="orderShuttle.email"><mat-icon>email</mat-icon>&nbsp;{{orderShuttle.email}}</span> -->
            <!-- </td>
                    <td colspan="7"> -->
            @if (orderShuttle.comment) {
            <span>&nbsp;Comments: {{orderShuttle.comment}}</span>
            }
          </td>
        </tr>
        }
        <!-- <mat-divider></mat-divider> -->
        }
      </table>
    </div>
  </mat-card>

  <!-- READY_TO_TRANSFER -->
  <mat-card class="group-card p-0">
    <mat-card-header class="card-header">
      <div class="d-flex flex-col pe-3">
        <mat-card-title>
          <mat-icon>local_parking</mat-icon>&nbsp;
          {{'SHUTTLE_CHECKIN.READY_TO_TRANSFER' |transloco}}
        </mat-card-title>
      </div>
      <div class="table-extras">
        <mat-checkbox [checked]="showCustDetailsPickup"
          (change)="changeShowCustDetailsPickup($event)"><mat-icon>person</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-checkbox [checked]="showFlightDetailsPickup"
          (change)="changeShowFlightDetailsPickup($event)"><mat-icon>flight</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-icon class="clickable" (click)="getOrderShuttlesPickup()">refresh</mat-icon>
      </div>
    </mat-card-header>
    <div class="p-0 table-responsive">
      <table>
        <tr>
          <th>{{ 'SHUTTLE_CHECKIN.NAME' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.REG_NO' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.PASSENGER' | transloco }}</th>
          @if (orderShuttleBus.routeType == 'DEPARTURE' ) {
          <th>{{ 'SHUTTLE_CHECKIN.READY_TO_TRANSFER' | transloco }}</th>
          }
          @if (orderShuttleBus.routeType == 'ARRIVAL' ) {
          <th>{{ 'SHUTTLE_CHECKIN.LANDED' | transloco }} / {{ 'SHUTTLE_CHECKIN.BOOKED_TIME' | transloco }}</th>
          }
          @if (orderShuttleBus.routeType == 'ARRIVAL' ) {
          <th>{{ 'SHUTTLE_CHECKIN.PICK_UP_TIME' | transloco }}</th>
          }
          <th>Station</th>
          <th>Destination</th>
          <th>{{ 'SHUTTLE_CHECKIN.ORDER_NO' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.CHECKED_IN' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.UNDO' | transloco }}</th>
          <th>No Show</th>
        </tr>
        <!-- <mat-divider></mat-divider> -->
        @for (orderShuttle of orderShuttlesPickup; track orderShuttle) {
        <tr [ngClass]="{'hotel-row': isHotel(orderShuttle), 'non-hotel-row': !isHotel(orderShuttle)}">
          <td (click)="goToOrder(orderShuttle)" class="clickable">
            {{ orderShuttle.firstName }} {{ orderShuttle.lastName }}
            @if (isHotel(orderShuttle)) {
            <mat-icon class="icon-bottom ms-1 icon-scale-small">hotel</mat-icon>
            }
            @if (orderShuttle.hasDevice) {
            <mat-icon class="icon-bottom icon-scale-tiny">mobile_friendly</mat-icon>
            }
            @if (orderShuttle.extra?.pressedButtonInApp) {
            <mat-icon class="icon-bottom icon-scale-tiny">waving_hand</mat-icon>
            }
            @if (isRedKeyStatus(orderShuttle.keyStatus) || isGreenKeyStatus(orderShuttle.keyStatus)) {
            <mat-icon class="icon-bottom"
              [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(orderShuttle.keyStatus) ? 'red' : (isGreenKeyStatus(orderShuttle.keyStatus) ? 'green' : '')}">key
            </mat-icon>
            @if (orderShuttle.orderSafe?.hookNo) {
            <span class="key-hook-number">{{ "(Hook No: " + orderShuttle.orderSafe.hookNo + ")" }}</span>
            }
            }
          </td>
          <td (click)="goToOrder(orderShuttle)" class="clickable"> {{ orderShuttle.orderParkingCarId }}
          </td>
          <td (click)="goToOrder(orderShuttle)" class="clickable">{{ orderShuttle.passengers }}</td>
          @if (orderShuttleBus.routeType == 'DEPARTURE') {
          @if(orderShuttle.orderParkingParkingSiteName){
          <td title="{{orderShuttle.shuttleUpdated | date:'yyyy-MM-dd HH:mm'}}">
            {{
            orderShuttle.shuttleUpdated | date: 'HH:mm' }}</td>
          }
          @if(!orderShuttle.orderParkingParkingSiteName){
          <td title="{{orderShuttle.shuttleDate | date:'yyyy-MM-dd HH:mm'}}">
            {{
            orderShuttle.shuttleDate | date: 'HH:mm' }}</td>
          }
          <td>
            @if (orderShuttle.orderParkingParkingSiteName == null) {
            <div>{{displayRouteName(orderShuttle)}}</div>
            }
            @if (orderShuttle.orderParkingParkingSiteName != null) {
            <div>
              @let hotelName = displayHotelName(orderShuttle.organizationId);
              @let siteName = removeLastPart(orderShuttle.orderParkingParkingSiteName);
              @if(hotelName){
              {{hotelName}}
              }@else{
              <span [style.color]="siteName === 'FP2' ? 'red' : 'inherit'">
                P-plats:&nbsp;{{ siteName }}
              </span>
              }
              <span [style.color]="siteName === 'FP2' ? 'red' : 'inherit'">
                &nbsp;Station:&nbsp;{{
                orderShuttle.shuttleTypeName }}
              </span>
            </div>
            }
          </td>
          @if (!orderShuttle.departureVM) {
          <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
            {{ orderShuttle.terminal }}</td>
          }
          @if (orderShuttle.departureVM) {
          <td
            [ngStyle]="{color:orderShuttle.departureVM.terminalName=='Terminal 5'||orderShuttle.departureVM.terminalName=='Terminal 4'?'black':'red'}">
            {{orderShuttle.departureVM.terminalName}}</td>
          }
          }
          @if (orderShuttleBus.routeType == 'ARRIVAL' ) {
          <td title="{{orderShuttle.passengerLandedOrBooked | date:'yyyy-MM-dd HH:mm'}}">
            {{ orderShuttle.passengerLandedOrBooked | date: 'HH:mm' }}
          </td>
          <td title="{{orderShuttle.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}"
            [ngStyle]="{color:orderShuttle.isReadyForPickup?'green':'black'}">
            {{ orderShuttle.shuttleDateNew | date: 'HH:mm' }}
          </td>
          @if (!orderShuttle.arrivalVM) {
          <td (click)="goToOrder(orderShuttle)" class="clickable"
            [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
            {{ orderShuttle.terminal }}
          </td>
          }
          @if (orderShuttle.arrivalVM) {
          <td (click)="goToOrder(orderShuttle)" class="clickable"
            [ngStyle]="{color:orderShuttle.arrivalVM.terminalName=='Terminal 5'||orderShuttle.arrivalVM.terminalName=='Terminal 4'?'black':'red'}">
            {{orderShuttle.arrivalVM.terminalName}}
          </td>
          }
          <td>
            @if (orderShuttle.orderParkingParkingSiteName == null) {
            <div>{{displayRouteName(orderShuttle)}}</div>
            }
            @if (orderShuttle.orderParkingParkingSiteName != null) {
            <div>
              @let hotelName = displayHotelName(orderShuttle.organizationId);
              @if(hotelName){
              {{hotelName}}
              }@else{
              @let siteName = removeLastPart(orderShuttle.orderParkingParkingSiteName);
              <span [style.color]="siteName === 'FP2' ? 'red' : 'inherit'">
                P-plats:&nbsp;{{ siteName }}
              </span>
              }
            </div>
            }
          </td>
          }
          <td> {{ orderShuttle.orderNr }}</td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleBoarded(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="primary">
              <mat-icon class="icon-center">arrow_upward</mat-icon>
            </button>
          </td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleReadyForPickup(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="primary">
              <mat-icon class="icon-center">arrow_downward</mat-icon>
            </button>
          </td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleNoShow(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="warn">
              <mat-icon class="icon-center">delete_outline</mat-icon>
            </button>
          </td>
        </tr>
        @if ((orderShuttle.departureVM && showFlightDetailsPickup) || (orderShuttle.arrivalVM &&
        showFlightDetailsPickup)) {
        <tr [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
          <td [attr.colspan]="orderShuttleBus.routeType === 'ARRIVAL' ? 11 : 10">
            @if (orderShuttle.departureVM && showFlightDetailsPickup) {
            <div>
              <app-back-office24-ordershuttlebus-departure
                [departureVM]="orderShuttle.departureVM"></app-back-office24-ordershuttlebus-departure>
            </div>
            }
            @if (orderShuttle.arrivalVM && showFlightDetailsPickup) {
            <div>
              <app-back-office24-ordershuttlebus-arrival
                [orderShuttleVM]="orderShuttle"></app-back-office24-ordershuttlebus-arrival>
            </div>
            }
          </td>
        </tr>
        }
        @if (showCustDetailsPickup) {
        <tr [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
          <td [attr.colspan]="orderShuttleBus.routeType === 'ARRIVAL' ? 11 : 10">
            @if (orderShuttle.cellular) {
            <span>Contact: &nbsp;{{orderShuttle.cellular}}</span>
            }
            <!-- </td>
                        <td>
                          <span
                            *ngIf="orderShuttle.email"><mat-icon>email</mat-icon>&nbsp;{{orderShuttle.email}}</span>
                          </td>
                          <td colspan="6"> -->
            @if (orderShuttle.comment) {
            <span>Comments: &nbsp;{{orderShuttle.comment}}</span>
            }
          </td>
        </tr>
        }
        <!-- <mat-divider></mat-divider> -->
        }
      </table>
    </div>
  </mat-card>

  <!-- OTHER_PASSENGERS -->
  <mat-card class="group-card p-0">
    <mat-card-header class="card-header">
      <div class="d-flex flex-col pe-3">
        <mat-card-title>
          <mat-icon>people</mat-icon>&nbsp;
          {{ 'SHUTTLE_CHECKIN.OTHER_CUSTOMERS' | transloco }}
        </mat-card-title>
      </div>
      <div class="table-extras">
        <mat-checkbox [checked]="showCustDetailsOther"
          (change)="changeShowCustDetailsOther($event)"><mat-icon>person</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-checkbox [checked]="showFlightDetailsOther"
          (change)="changeShowFlightDetailsOther($event)"><mat-icon>flight</mat-icon></mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
        <mat-icon class="clickable" (click)="getOrderShuttlesOther()">refresh</mat-icon>
      </div>
    </mat-card-header>
    <div class="p-0 table-responsive">
      <table>
        <tr>
          <th>{{ 'SHUTTLE_CHECKIN.NAME' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.REG_NO' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.PASSENGER' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.BOOKED_TIME' | transloco }}</th>
          @if (orderShuttleBus.routeType == 'ARRIVAL' ) {
          <th>{{ 'SHUTTLE_CHECKIN.PICK_UP_TIME' | transloco }}</th>
          }
          <th>Station</th>
          <th>Destination</th>
          <th>{{ 'SHUTTLE_CHECKIN.ORDER_NO' | transloco }}</th>
          <th>{{ 'SHUTTLE_CHECKIN.CHECKED_IN' | transloco }}</th>
          <th>No Show</th>
        </tr>
        <!-- <mat-divider></mat-divider> -->
        @for (orderShuttle of orderShuttlesOther; track orderShuttle) {
        <tr [ngClass]="{'hotel-row': isHotel(orderShuttle), 'non-hotel-row': !isHotel(orderShuttle)}">
          <td (click)="goToOrder(orderShuttle)" class="clickable">
            {{ orderShuttle.firstName }} {{ orderShuttle.lastName }}
            @if (isHotel(orderShuttle)) {
            <mat-icon class="icon-bottom ms-1 icon-scale-small">hotel</mat-icon>
            }
            @if (orderShuttle.hasDevice) {
            <mat-icon class="icon-bottom icon-scale-tiny">mobile_friendly</mat-icon>
            }
            @if (orderShuttle.extra?.pressedButtonInApp) {
            <mat-icon class="icon-bottom icon-scale-tiny">waving_hand</mat-icon>
            }
            @if (isRedKeyStatus(orderShuttle.keyStatus) || isGreenKeyStatus(orderShuttle.keyStatus)) {
            <mat-icon class="icon-bottom"
              [ngStyle]="{ 'transform': 'scale(0.7)', 'vertical-align': 'middle', 'color': isRedKeyStatus(orderShuttle.keyStatus) ? 'red' : (isGreenKeyStatus(orderShuttle.keyStatus) ? 'green' : '')}">key
            </mat-icon>
            @if (orderShuttle.orderSafe?.hookNo) {
            <span class="key-hook-number">{{ "(Hook No: " + orderShuttle.orderSafe.hookNo + ")" }}</span>
            }
            }
          </td>
          <td (click)="goToOrder(orderShuttle)" class="clickable"> {{ orderShuttle.orderParkingCarId }}
          </td>
          <td (click)="goToOrder(orderShuttle)" class="clickable"> {{ orderShuttle.passengers }}</td>
          <td title="{{orderShuttle.shuttleDate | date:'yyyy-MM-dd HH:mm'}}">
            {{ orderShuttle.shuttleDate | date: 'HH:mm' }}
          </td>
          @if (orderShuttleBus.routeType == 'DEPARTURE') {
          <td>
            @if (orderShuttle.orderParkingParkingSiteName == null) {
            <div>{{displayRouteName(orderShuttle)}}</div>
            }
            @if (orderShuttle.orderParkingParkingSiteName != null) {
            <div>
              @let hotelName = displayHotelName(orderShuttle.organizationId);
              @if(hotelName){
              {{hotelName}}
              }@else{
              @let siteName = removeLastPart(orderShuttle.orderParkingParkingSiteName);
              <span [style.color]="siteName === 'FP2' ? 'red' : 'inherit'">
                P-plats:&nbsp;{{ siteName }}
              </span>
              }
            </div>
            }
          </td>
          @if (!orderShuttle.departureVM) {
          <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
            {{ orderShuttle.terminal }}
          </td>
          }
          @if (orderShuttle.departureVM) {
          <td
            [ngStyle]="{color:orderShuttle.departureVM.terminalName=='Terminal 5'||orderShuttle.departureVM.terminalName=='Terminal 4'?'black':'red'}">
            {{orderShuttle.departureVM.terminalName}}
          </td>
          }
          }
          @if (orderShuttleBus.routeType == 'ARRIVAL') {
          <td title="{{orderShuttle.shuttleDateNew | date:'yyyy-MM-dd HH:mm'}}"
            [ngStyle]="{color:orderShuttle.isReadyForPickup?'green':'black'}">
            {{ orderShuttle.shuttleDateNew | date: 'HH:mm' }}
          </td>
          @if (!orderShuttle.arrivalVM) {
          <td [ngStyle]="{color:orderShuttle.terminal=='T5'||orderShuttle.terminal=='T4'?'black':'red'}">
            {{ orderShuttle.terminal }}
          </td>
          }
          @if (orderShuttle.arrivalVM) {
          <td
            [ngStyle]="{color:orderShuttle.arrivalVM.terminalName=='Terminal 5'||orderShuttle.arrivalVM.terminalName=='Terminal 4'?'black':'red'}">
            {{ orderShuttle.arrivalVM.terminalName}}
          </td>
          }
          <td>
            @if (orderShuttle.orderParkingParkingSiteName == null) {
            <div>{{displayRouteName(orderShuttle)}}</div>
            }
            @if (orderShuttle.orderParkingParkingSiteName != null) {
            <div>
              @let hotelName = displayHotelName(orderShuttle.organizationId);
              @if(hotelName){
              {{hotelName}}
              }@else{
              @let siteName = removeLastPart(orderShuttle.orderParkingParkingSiteName);
              <span [style.color]="siteName === 'FP2' ? 'red' : 'inherit'">
                P-plats:&nbsp;{{ siteName }}
              </span>
              }
            </div>
            }
          </td>
          }
          <td> {{ orderShuttle.orderNr }}</td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleBoarded(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="primary">
              <mat-icon class="icon-center">arrow_upward</mat-icon>
            </button>
          </td>
          <td class="text-center">
            <button mat-fab extended class="action-button" [disabled]="isBoardingDisabled"
              (click)="setOrderShuttleNoShow(orderShuttle.orderShuttleId, orderShuttleBus.orderShuttleBusId)"
              color="warn">
              <mat-icon class="icon-center">delete_outline</mat-icon>
            </button>
          </td>
        </tr>
        @if ((orderShuttle.departureVM && showFlightDetailsOther) || (orderShuttle.arrivalVM && showFlightDetailsOther))
        {
        <tr [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
          <td [attr.colspan]="orderShuttleBus.routeType === 'ARRIVAL' ? 10 : 9">
            @if (orderShuttle.departureVM && showFlightDetailsOther) {
            <div>
              <app-back-office24-ordershuttlebus-departure
                [departureVM]="orderShuttle.departureVM"></app-back-office24-ordershuttlebus-departure>
            </div>
            }
            @if (orderShuttle.arrivalVM && showFlightDetailsOther) {
            <div>
              <app-back-office24-ordershuttlebus-arrival
                [orderShuttleVM]="orderShuttle"></app-back-office24-ordershuttlebus-arrival>
            </div>
            }
          </td>
        </tr>
        }
        @if (showCustDetailsOther) {
        <tr [ngClass]="{'hotel-row-details': isHotel(orderShuttle), 'non-hotel-row-details': !isHotel(orderShuttle)}">
          <td [attr.colspan]="orderShuttleBus.routeType === 'ARRIVAL' ? 10 : 9">
            @if (orderShuttle.cellular) {
            <span>Contact: {{orderShuttle.cellular}}</span>
            }
            <!-- </td>
                              <td>
                                <span
                                  *ngIf="orderShuttle.email"><mat-icon>email</mat-icon>&nbsp;{{orderShuttle.email}}</span>
                                </td>
                                <td colspan="6"> -->
            @if (orderShuttle.comment) {
            <span>Comments: {{orderShuttle.comment}}</span>
            }
          </td>
        </tr>
        }
        <!-- <mat-divider></mat-divider> -->
        }
      </table>
    </div>
  </mat-card>

  <!-- </mat-accordion> -->
  <!-- </mat-accordion> -->
</div>